import React from 'react'
import { ReactComponent as WarningIcon } from '../../../../../assets/icons/warning.svg';
import { ReactComponent as SuccessIcon } from '../../../../../assets/icons/success.svg';
import './index.less'
export default function FailedOrSuccess(props) {
  const { status } = props;
  console.log(status)
  return (
    <div className='successOrFail'>
      {
        status == "success" ?
          <div className='successBg'>
            <SuccessIcon style={{ marginRight: 16 }} />
            <div>{props.t("Download Successful")}!</div>
          </div> : <div className='failBg'>
            <WarningIcon style={{ marginRight: 16, marginLeft: 20 }} />
            <div>{props.t('FailedToExtract')}</div>
          </div>
      }

    </div>

  )
}
